"use strict";

import Toolbox from "./../toolbox";

class Loop54Promos {

	#state = {
		promoItems: [],
		promoItemCounter: 0,
		itemCounter: 0,
		itemsBetweenPromosCounter: 0,
		selectedPromoIndex: 0,
		hasPromoItems: false
	};

	#config = {};

	constructor(config = {}) {

		this.#config = {
			// If no promo items were provided, we will use productPromoSelector to find them.
			promoItems: [],
			listingProductSelector: "article.product-list-item",
			listingSelector: ".js-search-results.product-list-grid",
			productPromoSelector: ".product-list-promo-item",
			promoItemShowAfterEvery: 8,
			promoItemRandomRange: 8,
			promoItemStartRange: 2,
			minItemsBetweenPromos: 2,
			maxItemsBetweenPromos: 8,
			showMaxPromoItems: 0,
			...config
		};

	}

	get state() {
		return this.#state;
	}

	get config() {
		return this.#config;
	}

	/**
	 * Get promotion item.
	 *
	 * @returns {Node} - Promotion item.
	 */
	getPromotionItem() {
		const info = document.createElement("div");
		let selectedPromo = 0;

		if (this.state.promoItems.length > 1) {

			for (let i = 0; i < this.state.promoItems.length; i++) {
				if (i > this.state.selectedPromoIndex) {
					selectedPromo = i;
					break;
				}

			}
		}

		this.state.selectedPromoIndex = selectedPromo;

		info.innerHTML = this.state.promoItems[selectedPromo];
		return info.firstChild;
	}

	/**
	 * Add promotion item.
	 *
	 * @param {Node} node - Node.
	 */
	addPromotionItem(node) {
		this.state.itemsBetweenPromosCounter = 0;
		this.state.promoItemCounter++;
		if (node) {
			node.parentNode.insertBefore(this.getPromotionItem(), node.nextSibling);
		}
	}

	/**
	 * This will add promotion items in existing product list.
	 *
	 * @returns {boolean} - True if page had promotion items, otherwise false.
	 */
	addPromotionItemsToList() {

		const listing = document.querySelector(this.config.listingSelector);

		if (!listing) {
			return false;
		}

		// Reset state.
		this.state.promoItems = [];
		this.state.promoItemCounter = 0;
		this.state.itemCounter = 0;
		this.state.itemsBetweenPromosCounter = 0;
		this.state.selectedPromoIndex = 0;
		this.state.hasPromoItems = false;

		const promoItemTemplates = this.config.promoItems && this.config.promoItems.length ? this.config.promoItems : document.querySelectorAll(this.config.productPromoSelector);

		if (promoItemTemplates.length) {
			this.state.hasPromoItems = true;
			for (const promoItem of promoItemTemplates) {
				this.state.promoItems.push(String(promoItem.textContent).trim());
			}

			// Let's keep the original order.
			// Toolbox.shuffleList(this.state.promoItems);
			this.config.showMaxPromoItems = this.state.promoItems.length;

		} else {
			return false;
		}

		const productItems = listing.querySelectorAll(this.config.listingProductSelector);


		this.addPromotionItems(productItems);

		return true;

	}

	/**
	 * Insert promotion items.
	 *
	 * @param {(Node[] | NodeList)} productItems
	 */
	addPromotionItems(productItems) {
		const randStart = Toolbox.randomBetween(0, Math.max(1, this.config.promoItemStartRange));

		for (let index = 0; index < productItems.length; index++) {

			if (this.state.promoItemCounter >= this.config.showMaxPromoItems) {
				break;
			}

			if (this.state.promoItemCounter < this.config.showMaxPromoItems) {

				const productItem = productItems[index];
				if (productItems.length > this.config.promoItemShowAfterEvery && (randStart === this.state.itemCounter)) {
					this.addPromotionItem(productItem);
					this.state.itemCounter = this.config.promoItemShowAfterEvery + this.config.promoItemRandomRange;
				} else {
					if (this.state.itemsBetweenPromosCounter > this.config.minItemsBetweenPromos) {
						const randomPromoPosition = Toolbox.randomBetween(this.config.promoItemShowAfterEvery - this.config.promoItemRandomRange, this.config.promoItemShowAfterEvery + this.config.promoItemRandomRange);
						if (this.state.itemCounter % randomPromoPosition === 0 && this.state.itemCounter !== 0) {
							this.addPromotionItem(productItem);
						}
					}
				}
				this.state.itemsBetweenPromosCounter++;
				this.state.itemCounter++;

				if ((this.state.itemsBetweenPromosCounter >= this.config.maxItemsBetweenPromos) && (this.state.promoItemCounter < this.config.showMaxPromoItems)) {
					this.addPromotionItem(productItem);
				}

			}

		}

		/*
		if (productItems.length > 0 && productItems.length <= this.config.promoItemShowAfterEvery && addedPromoItem === false
			&& (this.state.promoItemCounter < this.config.showMaxPromoItems)) {
			// Add all promo items to product list, becuase there are not enough products.
			const productList = document.querySelector(this.config.listingSelector);
			this.addRemainingPromotionItems(Array.from(productList.querySelectorAll(this.config.listingProductSelector)));
		} */
	}

}

export default Loop54Promos;
